import { Avatar, Tooltip } from '@fluentui/react-components';
import AvatarGroup from '@modules/users/components/AvatarGroup';

type TProps = { assignee?: string };
const TaskAssigneeLabel = ({ assignee }: TProps) =>
  assignee ? (
    <AvatarGroup ids={[assignee]} />
  ) : (
    <Tooltip withArrow relationship="label" content="Unassigned">
      <Avatar color="neutral" size={28} />
    </Tooltip>
  );
export default TaskAssigneeLabel;
